import React from 'react'
import { useState, useEffect } from 'react';
import '../../PlayerCard.css';
import axios from 'axios';

export default function Compfotopemain({ id_user }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [profil, setProfil] = useState([]);

    const getdata = async () => {
        try {
            const response = await axios.get(urlapi + "Profil?id=" + id_user);
            setProfil(response.data);
        } catch (error) { }
    };

    useEffect(() => {
        getdata();
    }, []);
    return (
        <>
            {profil.image == null || profil.image == '' ?


                <img
                    src='/img/dafaultpemain.png'
                    alt="Player"
                    className="player-img-card"
                />

                :
                <img
                    src={profil.image}
                    alt="Player"
                    className="player-img-card"
                />

            }
        </>
    )
}
